import React from 'react';

export const LoadingIndicator = ({ text = 'Loading...' }) => (
  <div className="LoadingIndicator" role="status">
    <div className="Spinner" />
    <span className="LoadingText">{text}</span>
  </div>
);

export default LoadingIndicator;
